import { Offer, Address } from '../types/offers';
import chevronRightIcon from '../assets/icons/chevron-right.svg';
import { formatReward } from '../utils/rewardFormatter';
import { BADGE_TEXT } from '../utils/constants';

interface OfferCardProps {
  offer: Offer;
  onClick: () => void;
}

const formatAddress = (location: Address): string => {
  const parts: string[] = [];

  if (location.street) parts.push(location.street);
  if (location.city) parts.push(location.city);
  if (location.state) parts.push(location.state);
  if (location.zipCode) parts.push(location.zipCode);

  return parts.join(', ');
};

export default function OfferCard({ offer, onClick }: OfferCardProps) {
  const { attributes } = offer;
  const logoImage = attributes.assets.find(asset => asset.type === 'IMG_VIEW');

  // Determine badge text
  const getBadgeText = () => {
    if (attributes.is_local) {
      return BADGE_TEXT.NEARBY;
    }

    const channels = attributes.purchase_channel;
    if (channels.includes('ONLINE') && channels.includes('INSTORE')) {
      return BADGE_TEXT.ONLINE_AND_IN_STORE;
    } else if (channels.includes('ONLINE')) {
      return BADGE_TEXT.ONLINE;
    } else if (channels.includes('INSTORE')) {
      return BADGE_TEXT.IN_STORE;
    }
    return null;
  };

  const badgeText = getBadgeText();

  return (
    <div className="py-4 cursor-pointer" onClick={onClick}>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          {logoImage && (
            <div className="h-14 w-14 mr-4 flex-shrink-0">
              <img
                src={logoImage.url + (logoImage.url.includes('?') ? '&' : '?') + 'eventCode=IMPRESSION'}
                alt={logoImage.alt || attributes.name}
                className="w-full h-full object-contain rounded-full"
              />
            </div>
          )}
          <div>
            <p className="label-medium">{attributes.name}</p>
            <p className="paragraph-medium text-chartreuse-800">{formatReward(attributes.user_reward)}</p>
            {attributes.location && (
              <p className="paragraph-small text-gray-600 mt-1">{formatAddress(attributes.location)}</p>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          {badgeText && (
            <span className="px-2 py-1 rounded-[50px] paragraph-small bg-badge text-badge">
              {badgeText}
            </span>
          )}
          <img src={chevronRightIcon} alt="View offer" className="w-[8px] h-[14px] flex-shrink-0" />
        </div>
      </div>
    </div>
  );
}